import { classes } from '~/helpers';
import { HTMLShopifySectionElement } from '~/html-shopify-section-element';

class FeaturedProducts extends HTMLShopifySectionElement {
  connectedCallback() {
    if (super.connectedCallback) super.connectedCallback();

    if (this.targets.control) {
      this.on('click', this.targets.control.all, (event) => {
        if (this.targets.products) {
          for (const element of [...this.targets.control.all, ...this.targets.products.all]) {
            element.classList.toggle(classes.active, element.dataset.category === event.currentTarget.dataset.category);
          }
        }
      });
    }
  }
}

if (!customElements.get('featured-products')) customElements.define('featured-products', FeaturedProducts);
